/* Offroad Aesthetics - show product brand/vendor in the cart drawer.
   The cart drawer renders line items client-side, so we read the vendor
   from Shopify's cart.js and insert a coral kicker above each item title,
   matched by product handle so it stays correct through add/remove/qty. */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_URL = ROOT.replace(/\/$/, '') + '/cart.js';
  var lastCart = null;
  var timer = null;

  function apply(cart) {
    if (!cart || !cart.items) return;
    var vmap = {};
    cart.items.forEach(function (it) {
      if (it && it.handle && it.vendor) vmap[it.handle] = it.vendor;
    });
    var titles = document.querySelectorAll('[data-line-items] .cart__items__title');
    for (var i = 0; i < titles.length; i++) {
      var tw = titles[i];
      var a = tw.querySelector('a');
      if (!a) continue;
      var href = a.getAttribute('href') || '';
      var m = href.match(/\/products\/([^/?#]+)/);
      var vendor = m ? vmap[m[1]] : null;
      if (!vendor) continue;
      var existing = tw.querySelector('.cart__items__vendor');
      if (existing) {
        if (existing.textContent !== vendor) existing.textContent = vendor;
        continue;
      }
      var p = document.createElement('p');
      p.className = 'cart__items__vendor';
      p.textContent = vendor;
      tw.insertBefore(p, tw.firstChild);
    }
  }

  function refresh() {
    fetch(CART_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; apply(c); })
      .catch(function () {});
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      if (lastCart) apply(lastCart);
      refresh();
    }, 120);
  }

  document.addEventListener('theme:cart:change', function (e) {
    if (e && e.detail && e.detail.cart) { lastCart = e.detail.cart; apply(e.detail.cart); }
    else schedule();
  });
  document.addEventListener('theme:cart:added', schedule);

  function init() {
    refresh();
    var container = document.querySelector('[data-line-items]');
    if (container && window.MutationObserver) {
      var mo = new MutationObserver(function () {
        if (lastCart) apply(lastCart);
        else schedule();
      });
      mo.observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Offroad Aesthetics - capped product gallery + lightbox UX.
   Stacked desktop layout only (mobile carousel untouched). Shows the first 3
   images; the rest go in an overflow thumbnail strip. Clicking ANY main image or
   a thumbnail opens the theme's PhotoSwipe lightbox over the full set. Adds clear
   arrows + mouse drag-to-swipe. Syncs the gallery to the selected variant so the
   right image is revealed and highlighted on desktop. ES5 only (shares a file
   with the cart-vendor feature). */
(function () {
  'use strict';

  var CAP = 3;

  var CSS = [
    /* cap: hide images beyond the first 3 on desktop */
    '@media only screen and (min-width:768px){.product__grid--single.oa-capped [data-media-slide]:nth-child(n+4){display:none!important}}',
    /* but always keep the selected variant image visible */
    '@media only screen and (min-width:768px){.product__grid--single.oa-capped [data-media-slide].oa-variant-shown{display:block!important}}',
    /* DESKTOP only: remove the magnify button (mobile keeps its native magnify) */
    '@media only screen and (min-width:768px){.product-single .media__button--zoom{display:none!important}}',
    '@media only screen and (min-width:768px){.product__grid--single [data-media-slide] .product-image-wrapper{cursor:zoom-in}}',
    /* overflow strip */
    '.oa-gallery-more{display:none}',
    '@media only screen and (min-width:768px){.oa-gallery-more.oa-capped-more{display:block;margin-top:16px}}',
    '.oa-gallery-more__thumbs{display:flex;flex-wrap:wrap;gap:8px}',
    '.oa-gallery-more__thumb{-webkit-appearance:none;appearance:none;position:relative;width:72px;height:72px;padding:0;border:1px solid #e3e3e3;border-radius:8px;overflow:hidden;cursor:pointer;background:#fff;transition:border-color .15s ease,transform .15s ease}',
    '.oa-gallery-more__thumb img{width:100%;height:100%;object-fit:cover;display:block}',
    '.oa-gallery-more__thumb:hover{border-color:#ff5c5c;transform:translateY(-1px)}',
    /* DESKTOP only: keep the theme's default arrows, vertically center + inset from the edges */
    '@media only screen and (min-width:768px){.pswp__button--arrow--left,.pswp__button--arrow--right{position:fixed!important;top:50%!important;bottom:auto!important;margin-top:0!important;transform:translateY(-50%)!important;z-index:2000!important}}',
    '@media only screen and (min-width:768px){.pswp__button--arrow--left{left:32px!important;right:auto!important}}',
    '@media only screen and (min-width:768px){.pswp__button--arrow--right{right:32px!important;left:auto!important}}',
    '.pswp--open{cursor:grab}',
    '.pswp--open.oa-dragging{cursor:grabbing}',
    /* Product card price emphasis - global fallback so ALL grids match, incl. collections with no reviews (product-rating.liquid also sets this for review pages). All viewports. */
    '.product-grid-item .product__grid__price,.product-grid-item .product__grid__price .price{font-size:18px!important;font-weight:600!important}',
    /* Hide the redundant "Sold Out" text under the price - the SOLD OUT badge on the card already says it. All viewports. */
    '.product-grid-item .product__grid__price__sold{display:none!important}',
    /* Judge.me review widget polish - solid gray empty stars, tucked+centered preview badge, bold Customer Reviews header. All viewports. */
    '.jdgm-star.jdgm--off::before{content:"\\e000"!important;color:#dcdcdc!important}',
    '.jdgm-prev-badge{display:block!important;text-align:center!important;line-height:1!important;margin:-6px 0 22px!important}',
    '.jm-review-widget-minimal-header__title{font-weight:700!important}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('oa-gallery-css')) return;
    var st = document.createElement('style');
    st.id = 'oa-gallery-css';
    st.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(st);
  }

  function sized(url, w) {
    try {
      var u = new URL(url, window.location.href);
      u.searchParams.set('width', w);
      u.searchParams.delete('height');
      return u.toString();
    } catch (e) { return url; }
  }

  function build(slideshow) {
    if (!slideshow || slideshow.getAttribute('data-oa-capped')) return;
    if (!slideshow.classList.contains('product__grid--single')) return;

    var slides = slideshow.querySelectorAll('[data-media-slide]');
    if (slides.length <= CAP) { slideshow.setAttribute('data-oa-capped', 'skip'); return; }

    slideshow.setAttribute('data-oa-capped', '1');
    slideshow.classList.add('oa-capped');

    var wrap = document.createElement('div');
    wrap.className = 'oa-gallery-more oa-capped-more';

    var thumbs = document.createElement('div');
    thumbs.className = 'oa-gallery-more__thumbs';

    for (var i = CAP; i < slides.length; i++) {
      var slide = slides[i];
      var srcImg = slide.querySelector('img');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'oa-gallery-more__thumb';
      btn.setAttribute('data-oa-open-index', String(i));
      btn.setAttribute('aria-label', 'View photo ' + (i + 1));
      var im = document.createElement('img');
      im.loading = 'lazy';
      var raw = srcImg ? (srcImg.getAttribute('src') || srcImg.currentSrc || srcImg.src) : '';
      im.src = raw ? sized(raw, 160) : '';
      im.alt = srcImg ? (srcImg.getAttribute('alt') || '') : '';
      btn.appendChild(im);
      thumbs.appendChild(btn);
    }
    wrap.appendChild(thumbs);
    slideshow.parentNode.insertBefore(wrap, slideshow.nextSibling);
  }

  function slideshowEl() {
    return document.querySelector('[data-product-slideshow].product__grid--single');
  }

  function openAt(slideshow, index) {
    if (!slideshow) return;
    var slides = slideshow.querySelectorAll('[data-media-slide]');
    var slide = slides[index];
    if (!slide) return;
    var zoomBtn = slide.querySelector('[data-zoom-button]');
    if (zoomBtn) { zoomBtn.click(); return; }
    var img = slide.querySelector('img');
    if (img) img.click();
  }

  /* Click a main image -> open the lightbox at that image. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (!window.matchMedia || !window.matchMedia('(min-width:768px)').matches) return;

    var thumb = e.target.closest('[data-oa-open-index]');
    if (thumb) {
      var wrap = thumb.closest('.oa-gallery-more');
      if (wrap) {
        e.preventDefault();
        openAt(slideshowEl(), parseInt(thumb.getAttribute('data-oa-open-index'), 10));
        return;
      }
    }

    var slideEl = e.target.closest('[data-product-slideshow].product__grid--single [data-media-slide]');
    if (slideEl && slideEl.querySelector('[data-zoom-button]')) {
      var ss = slideEl.closest('[data-product-slideshow]');
      var all = ss.querySelectorAll('[data-media-slide]');
      var idx = Array.prototype.indexOf.call(all, slideEl);
      if (idx > -1) { e.preventDefault(); openAt(ss, idx); }
    }
  });

  /* Mouse drag-to-swipe inside the lightbox (touch already swipes natively). */
  var dragX = null, dragY = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    var pswp = document.querySelector('.pswp.pswp--open');
    if (!pswp || !pswp.contains(e.target)) return;
    if (e.target.closest('.pswp__button')) return;
    if (pswp.classList.contains('pswp--zoomed-in')) return;
    dragX = e.clientX; dragY = e.clientY;
    pswp.classList.add('oa-dragging');
  });
  document.addEventListener('pointerup', function (e) {
    if (dragX === null) return;
    var dx = e.clientX - dragX, dy = e.clientY - dragY;
    dragX = null; dragY = null;
    var pswp = document.querySelector('.pswp.pswp--open');
    if (pswp) pswp.classList.remove('oa-dragging');
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
      var sel = dx < 0 ? '.pswp__button--arrow--right' : '.pswp__button--arrow--left';
      var btn = document.querySelector(sel);
      if (btn) btn.click();
    }
  });

  /* ---- Variant -> image sync (desktop) ---- */
  var variantMediaMap = null;
  var lastVariant = null;

  function currentVariantId() {
    var inp = document.querySelector('[data-product-form-wrapper] [name="id"], form[action*="/cart/add"] [name="id"]');
    if (inp && inp.value) return inp.value;
    try { return new URLSearchParams(window.location.search).get('variant'); } catch (e) { return null; }
  }

  function revealForVariant() {
    var ss = slideshowEl();
    if (!ss || !variantMediaMap) return;
    var vid = currentVariantId();
    if (!vid) return;
    var mid = variantMediaMap[String(vid)];
    var prev = ss.querySelectorAll('.oa-variant-active, .oa-variant-shown');
    for (var k = 0; k < prev.length; k++) { prev[k].classList.remove('oa-variant-active'); prev[k].classList.remove('oa-variant-shown'); }
    if (!mid) return;
    var slide = ss.querySelector('[data-media-slide][data-media-id="' + mid + '"]');
    if (!slide) return;
    slide.classList.add('oa-variant-shown', 'oa-variant-active');
    if (window.matchMedia && window.matchMedia('(min-width:768px)').matches) {
      try { slide.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
    }
  }

  function loadVariantMap() {
    var el = document.querySelector('[data-product-json]');
    var handle = null;
    if (el) { try { handle = JSON.parse(el.textContent).handle; } catch (e) {} }
    if (!handle) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root.replace(/\/$/, '') + '/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        variantMediaMap = {};
        (p.variants || []).forEach(function (v) {
          if (v && v.featured_media && v.featured_media.id != null) variantMediaMap[String(v.id)] = String(v.featured_media.id);
        });
        lastVariant = currentVariantId();
        revealForVariant();
      })
      .catch(function () {});
  }

  function pollVariant() {
    var vid = currentVariantId();
    if (vid && vid !== lastVariant) { lastVariant = vid; revealForVariant(); }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-product-slideshow]').forEach(build);
  }

  function boot() {
    injectCSS();
    initAll(document);
    if (document.querySelector('[data-product-slideshow].product__grid--single')) {
      loadVariantMap();
      setInterval(pollVariant, 350);
    }
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('[data-product-slideshow]')) build(n);
            else if (n.querySelectorAll) n.querySelectorAll('[data-product-slideshow]').forEach(build);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
/* Offroad Aesthetics - Judge.me "minimal" review widget: make EMPTY rating stars solid gray
   to match the preview badge + product cards. That widget renders each star as
   .jm-star-rating__font-icon with the glyph in the element's TEXT (filled = U+E000,
   empty/outline = U+E001) and NO class difference between full and empty, so CSS cannot
   target only the empties. Swap the outline glyph to the solid one and color it gray, in JS.
   A MutationObserver re-applies on lazy-loaded / paginated / re-sorted reviews. */
(function () {
  'use strict';
  var FILLED = String.fromCharCode(0xE000);
  function grayEmpties(root) {
    var icons = (root || document).querySelectorAll('.jm-star-rating__font-icon');
    for (var i = 0; i < icons.length; i++) {
      var ic = icons[i];
      if (ic.getAttribute('data-oa-gray') === '1') continue;
      var t = ic.textContent;
      if (t && t.charCodeAt(0) === 0xE001) {
        ic.style.color = '#dcdcdc';
        ic.textContent = FILLED;
        ic.setAttribute('data-oa-gray', '1');
      }
    }
  }
  function boot() {
    grayEmpties(document);
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('.jm-star-rating__font-icon')) grayEmpties(n.parentNode || n);
            else if (n.querySelector) grayEmpties(n);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
